import { ACTION } from './project_inv_actions';
import {
  list_reducer,
  update_reducer,
  delete_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  totalCount: 0,
  filteredCount: 0,
  isLoading: false,
  isCreating: false,
  isAccepting: false,
  isRejecting: false,
  isRevoking: false,
  invitation: null,
  errorMessage: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        isCreating: false,
        invitation: action.payload,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
        totalCount: action.payload.recordsTotal,
        filteredCount: action.payload.recordsFiltered,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.ACCEPT}_PENDING`:
      return {
        ...state,
        isAccepting: true,
        errorMessage: null,
      };
    case `${ACTION.ACCEPT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isAccepting: false,
        errorMessage: null,
      };
    case `${ACTION.ACCEPT}_REJECTED`:
      return {
        ...state,
        isAccepting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REJECT}_PENDING`:
      return {
        ...state,
        isRejecting: true,
        errorMessage: null,
      };
    case `${ACTION.REJECT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isRejecting: false,
        errorMessage: null,
      };
    case `${ACTION.REJECT}_REJECTED`:
      return {
        ...state,
        isRejecting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REVOKE}_PENDING`:
      return {
        ...state,
        isRevoking: true,
        errorMessage: null,
      };
    case `${ACTION.REVOKE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isRevoking: false,
        errorMessage: null,
      };
    case `${ACTION.REVOKE}_REJECTED`:
      return {
        ...state,
        isRevoking: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/project_inv/project_inv_reducer.js